import { useMutation } from '@/core/hooks/use-mutation'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { forgotPassword } from '../../providers/client'
import { useEmailAuthStore } from '../../store/email-auth'
import { forgotPasswordSchema } from '../../types/dtos/forgot-password.dto'

export const useForgotPassword = ({ onSuccess }: { onSuccess: () => void }) => {
  const { setEmail } = useEmailAuthStore()
  const form = useForm({
    defaultValues: {
      email: '',
    },
    resolver: zodResolver(forgotPasswordSchema),
  })

  const { isPending, mutate } = useMutation({
    mutation: forgotPassword,
    onSuccess(_, { email }) {
      setEmail(email)
      onSuccess()
    },
    onError(error) {
      form.setError('email', { message: error })
    },
  })

  const handleSubmit = form.handleSubmit(mutate)

  return { form, handleSubmit, isPending }
}
